import * as yup from 'yup';

const ReportPaymentsInvoices = yup.object().shape({
   start: yup
    .date()
    .required('La fecha de inicio es requerida')
    .typeError('La fecha de inicio debe ser una fecha válida')
    .test('is-before-end', 'La fecha de inicio no puede ser mayor que la fecha de fin', function(value) {
      const { end } = this.parent;
      return !end || value <= end;
    }),
  end: yup
    .date()
    .required('La fecha de fin es requerida')
    .typeError('La fecha de fin debe ser una fecha válida')
    .test('is-after-start', 'La fecha de fin no puede ser menor que la fecha de inicio', function(value) {
      const { start } = this.parent;
      return !start || value >= start;
    }),
  operator: yup
    .string()
    .required('El operador es requerido')
    .typeError('El operador debe ser una cadena de texto'),
    
  status: yup
    .string()
    .required('El estado es requerido')
    .typeError('El estado debe ser una cadena de texto'),

  paymentTypes: yup
    .string()
    .required('El tipo de pago es requerido'),

  companyType: yup
    .string()
    .required('El tipo de compañía es requerido'),

  paymentStart: yup.date().nullable().typeError('Debe ser una fecha válida'),
  paymentEnd: yup.date().nullable().typeError('Debe ser una fecha válida'),
  invoiceStart: yup.date().nullable().typeError('Debe ser una fecha válida'),
  invoiceEnd: yup.date().nullable().typeError('Debe ser una fecha válida'),
}).test(
  'valid-payment-range',
  'El rango de fechas de pago es inválido',
  function (values) {
    const { paymentStart, paymentEnd } = values;
    if (paymentStart || paymentEnd) {
      if (!paymentStart || !paymentEnd) return this.createError({ path: 'paymentStart', message: 'Ambas fechas de pago son requeridas' });
      if (paymentStart > paymentEnd) return this.createError({ path: 'paymentStart', message: 'La fecha de inicio de pago no puede ser mayor que la fecha de fin' });
    }
    return true;
  }
).test(
  'valid-invoice-range',
  'El rango de fechas de factura es inválido',
  function (values) {
    const { invoiceStart, invoiceEnd } = values;
    if (invoiceStart || invoiceEnd) {
      if (!invoiceStart || !invoiceEnd) return this.createError({ path: 'invoiceStart', message: 'Ambas fechas de factura son requeridas' });
      if (invoiceStart > invoiceEnd) return this.createError({ path: 'invoiceStart', message: 'La fecha de inicio de factura no puede ser mayor que la fecha de fin' });
    }
    return true;
  }
);


export default ReportPaymentsInvoices;
